/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.InventoryTurnsAnalysis {
  angular.module("meevo.plugins.inventoryTurnsAnalysis", []);
}
